import './static-page.css';
import { ThemeToggle, useStaticPageTheme } from './theme-toggle';

export function PrivacyPage() {
  const { theme, setTheme } = useStaticPageTheme();

  return (
    <div className="static-page">
      <main className="static-page-content">
        <div className="static-page-header">
          <h1>Privacy Policy</h1>
          <ThemeToggle theme={theme} setTheme={setTheme} />
        </div>
        <p className="subtitle">Strong's KJV Bible App</p>

        <p>
          Strong's KJV ("the App") provides Bible reading and word study ("the Service") to users.
          This Privacy Policy describes how personal information is collected, used, and shared when
          you install or use the App.
        </p>

        <h2>Personal Information We Collect</h2>
        <p>We do not collect any personal information.</p>

        <h2>How We Use Your Personal Information</h2>
        <p>No personal information is collected or used.</p>

        <h2>Sharing Your Personal Information</h2>
        <p>
          We do not collect any personal information and therefore do not share any personal
          information with any third parties.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this privacy policy from time to time in order to reflect changes to our
          practices or for other operational, legal, or regulatory reasons. We will notify users
          of any changes within the Strong's KJV app.
        </p>

        <h2>Contact Us</h2>
        <p>
          For more information about our privacy practices, if you have questions, or if you would
          like to make a complaint, please contact us by{' '}
          <a href="mailto:support@skjv.ai">email</a>.
        </p>

        <footer>
          <a href="/">Strong's KJV</a> · <a href="/support">Support</a> ·{' '}
          <a href="/terms">Terms</a>
        </footer>
      </main>
    </div>
  );
}
